import { TableColumn } from "react-data-table-component";
import { Edit3, Trash2, Download } from "react-feather";
import { Btn } from "../../AbstractElements";
import { Fragment, useState } from "react";
import Swal from "sweetalert2";
import { useMutation, useQueryClient } from "@tanstack/react-query";

//MODAL
import UpdateAttachmentModal from "../../Components/UiKits/Modal/Employee/UpdateAttachment";

//SERVICES
import {
  VIEW_EMPATTACHMENTS_QUERY_KEY,
  employeeAttachmentsService,
} from "../../Services/employeeAttachmentServices";

//TYPE
import { ViewEmployeeAttachment } from "../../Types/Employee/EmployeeAttachment";
import { CRUDPermissions } from "../../Types/Common/Access";

const ActionCell = ({
  row,
  access,
}: {
  row: ViewEmployeeAttachment;
  access: CRUDPermissions;
}) => {
  const queryClient = useQueryClient();
  const [Updatemodal, setUpdateModal] = useState(false);
  const [Candidatemodal, setCandidatemodal] = useState(false);
  const toggleCandidateModal = () => {
    setCandidatemodal(!Candidatemodal);
  };

  const Updatetoggle = () => {
    setUpdateModal(!Updatemodal);
  };

  const handleDownload = async () => {
    try {
      const response = await employeeAttachmentsService.downloadAttachment(
        row.file_path,
      );

      const url = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = url;
      link.download = row.file_name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: `ERROR ${error.response?.status || ""}`,
        text: "Attachment Not Found.",
        confirmButtonColor: "#4e73df",
      });
    }
  };

  const toggleMutation = useMutation({
    mutationFn: employeeAttachmentsService.toggleStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: VIEW_EMPATTACHMENTS_QUERY_KEY,
      });
      Swal.close();
      Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "success",
        title: "Transaction Successful",
        text: "Attached File has been removed successfully.",
        confirmButtonColor: "#4e73df",
      });
    },
    onError: (error: any) => {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Transaction Failed",
        text:
          error.response?.data?.message ||
          "Failed to Remove Attachment please reload and try again.",
        confirmButtonColor: "#4e73df",
      });
    },
  });

  const handleRemove = () => {
    Swal.fire({
      icon: "question",
      html: `Are you sure you want to remove this attachment?`,
      showCancelButton: true,

      confirmButtonText: '<i class="fa fa-trash"></i> Remove Attachment',
      cancelButtonText: '<i class="fa fa-times"></i> Cancel',

      confirmButtonColor: "#4e73df", // Primary
      cancelButtonColor: "#dc3545", // Danger
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Removing Attachment...",
          text: "Please wait while your attachment file is being removed.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        toggleMutation.mutate(row.id);
      }
    });
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Btn
        size="sm"
        color="primary"
        className="px-2"
        onClick={handleDownload}
        hidden={!access.read}
      >
        <Download size={11} /> Download
      </Btn>

      {row.origin === "EMP" && (
        <>
          <Btn
            size="sm"
            color="info"
            className="px-2"
            onClick={Updatetoggle}
            hidden={!access.update}
          >
            <Edit3 size={11} /> Update
          </Btn>

          <Btn
            size="sm"
            color="danger"
            className="px-2"
            onClick={handleRemove}
            hidden={!access.update}
          >
            <Trash2 size={11} /> Remove
          </Btn>

          <UpdateAttachmentModal
            modal={Updatemodal}
            attachment_id={row.id}
            category_id={row.category_id}
            file_name={row.file_name}
            toggle={Updatetoggle}
          />
        </>
      )}
    </div>
  );
};

export const AttachmeneTableColumn = (
  access: CRUDPermissions,
): TableColumn<ViewEmployeeAttachment>[] => [
  {
    name: "File Name",
    selector: (row) => row.file_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{row.file_name}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "Attachment Category",
    selector: (row) => row.category_name,
    sortable: true,
    center: false,
  },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "ACTION",
    sortable: false,
    center: false,
    cell: (row) => <ActionCell row={row} access={access} />,
  },
];
